import Head from 'next/head';
import { useRouter } from 'next/router';

export default function AppHead() {
  const router = useRouter();
  return (
    <Head>
      <meta
        name="apple-itunes-app"
        content={`app-id=1535120978, app-argument=${router?.asPath ?? '/'}`}
      />
      {/* This is lies and isn't real */}
      {/* <meta name="google-play-app" content="app-id=com.greenr.app" /> */}
    </Head>
  );
}
